export default __webpack_public_path__ + "locales/sk/ConnectDialog.json?hash=f4a9fae6b6151a2b6622ce2845a4781b";